module.exports = __webpack_public_path__ + "img/storagebg.68b6f9b4.png";